import { ANNOUNCEMENT_EVENTS, announcementService } from '@moal/api'
import { useContext, useEffect } from 'react'
import { SocketContext } from '../../context/socketContext'
import { SiteConfigContext } from '../../context/siteConfigContext'
import { PRODUCT_CODE } from '../../utils/ENV'

const LatestAnnouncement = ({ children }) => {
  const { announcementsSocket: socket } = useContext(SocketContext)
  const { latestAnnouncement, setLatestAnnouncement, loadLatestAnnouncement } =
    useContext(SiteConfigContext)

  useEffect(() => {
    if (socket) {
      socket.on(ANNOUNCEMENT_EVENTS.POST, addAnnouncement)
      socket.on(ANNOUNCEMENT_EVENTS.EDIT, editAnnouncement)
      socket.on(ANNOUNCEMENT_EVENTS.DELETE, deleteAnnouncement)
      socket.on(ANNOUNCEMENT_EVENTS.READ, editAnnouncement)
      socket.on(ANNOUNCEMENT_EVENTS.READ_ALL, handleAllRead)
    }

    return () => {
      if (socket) {
        socket.off(ANNOUNCEMENT_EVENTS.POST, addAnnouncement)
        socket.off(ANNOUNCEMENT_EVENTS.EDIT, editAnnouncement)
        socket.off(ANNOUNCEMENT_EVENTS.DELETE, deleteAnnouncement)
        socket.off(ANNOUNCEMENT_EVENTS.READ, editAnnouncement)
        socket.off(ANNOUNCEMENT_EVENTS.READ_ALL, handleAllRead)
      }
    }
  }, [socket, latestAnnouncement])

  const addAnnouncement = (data) => {
    if (data.itemNumber === PRODUCT_CODE) {
      setLatestAnnouncement(data)
    }
  }

  const editAnnouncement = (data) => {
    if (
      data.itemNumber === PRODUCT_CODE &&
      latestAnnouncement &&
      latestAnnouncement._id === data._id
    ) {
      setLatestAnnouncement(data)
    }
  }

  const deleteAnnouncement = (data) => {
    if (
      data.itemNumber === PRODUCT_CODE &&
      latestAnnouncement &&
      latestAnnouncement._id === data._id
    ) {
      loadLatestAnnouncement()
    }
  }

  const handleAllRead = () => {
    setLatestAnnouncement({ ...latestAnnouncement, read: new Date() })
  }

  const markLatestAnnouncementRead = async () => {
    if (!latestAnnouncement || latestAnnouncement.read) {
      return
    }
    try {
      await announcementService.markAsRead(latestAnnouncement._id)
    } catch {
      console.error('Error marking announcement as read')
    }
  }

  return children({
    latestAnnouncement,
    markLatestAnnouncementRead
  })
}

export default LatestAnnouncement
